import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IconGift } from '../../elements/Icon';

const WEEK_DAYS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

function getLast9Days() {
  const result = [];
  const today = new Date();

  for (let i = 8; i >= 0; i--) {
    const d = new Date(today);
    d.setUTCDate(today.getUTCDate() - i);

    result.push({
      key: d.toISOString().split('T')[0],
      day: d.getUTCDate(),
      weekDay: WEEK_DAYS[d.getUTCDay()],
    });
  }

  return result;
}

export const Gift = ({ onClose, days }) => {
  const { t } = useTranslation();

  const profile = JSON.parse(localStorage.getItem('profile') || '{}');

  const dailyGift = profile?.dailyGift || {};

  const last9Days = useMemo(() => {
    const dates = getLast9Days();

    return dates.map((item, index) => {
      const value = dailyGift[item.key] || 0;

      return {
        ...item,
        value,
        enabled: !!dailyGift[item.key],
        weekDay: item.weekDay,
      };
    });
  }, [dailyGift]);

  return (
    <div
      onClick={onClose}
      className="w-full h-full absolute z-[60] bg-black/30 flex justify-center items-center px-4"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="
          relative
          w-full max-w-[760px]
          rounded-[18px]
          border-[3px]
          border-[#7743BA]
          bg-[#F8F4EA]
          px-[18px]
          py-[18px]
          shadow-xl
        "
      >
        <div className="flex justify-center items-center gap-2 mb-6">
          <h2 className="
            text-[#4B96C9]
            text-[24px]
            md:text-[34px]
            font-bold
            text-center
          ">
             {days === 1
                            ? t("presentPopUpOne")
                            : t("presentPopUp").replace("X", days)}
          </h2>

          <IconGift className="w-[28px] h-[28px] md:w-[36px] md:h-[36px]" />
        </div>

        <div className="grid grid-cols-9 gap-2 md:gap-3">
          {last9Days.map((item, index) => (
            <div
              key={item.key}
              className="
                rounded-[10px]
                bg-[#EEE9F4]
                flex
                flex-col
                items-center
                py-3
                min-h-[132px]
              "
            >
              <span className="
                text-[10px]
                md:text-[12px]
                font-semibold
                text-[#A89BBC]
                mb-2
              ">
                {item.weekDay}
              </span>

              <div
                className={`
                  w-[28px]
                  h-[28px]
                  md:w-[34px]
                  md:h-[34px]
                  rounded-[6px]
                  flex
                  items-center
                  justify-center
                  text-white
                  font-bold
                  text-[14px]
                  md:text-[16px]
                  mb-5
                  ${item.enabled
                    ? 'bg-[#6E3CB8]'
                    : 'bg-[#C9BEDC]'}
                `}
              >
                {item.day}
              </div>

              <div
                className={`
                  mb-2
                  ${item.enabled ? 'opacity-100' : 'opacity-40'}
                `}
              >
                <IconGift className="w-[26px] h-[26px] md:w-[32px] md:h-[32px]" />
              </div>

              <span
                className={`
                  text-[13px]
                  md:text-[16px]
                  font-semibold
                  ${item.enabled
                    ? 'text-[#6E3CB8]'
                    : 'text-[#B8A9D1]'}
                `}
              >
                {item.value}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
